import { I as t } from "../../constants-DeVuDy8J.js";
import { createElementBlock as r, openBlock as s, normalizeClass as n, createElementVNode as o } from "vue";
import { _ as d } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
const l = {
  name: "DtIconPastConversations",
  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: String,
      default: "500",
      validator: (e) => Object.keys(t).includes(e)
    },
    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: void 0
    }
  },
  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ["loaded"],
  computed: {
    iconSizeClass() {
      return t[this.size];
    },
    ariaHidden() {
      return this.ariaLabel ? "false" : "true";
    },
    dataQA() {
      return this.$attrs["data-qa"] ?? "dt-icon";
    }
  },
  created() {
    this.$emit("loaded");
  }
}, c = ["aria-label", "data-qa", "aria-hidden"], _ = /* @__PURE__ */ o("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M6.5 2.5A1.5 1.5 0 0 0 5 4v1.5a.5.5 0 0 1-1 0V4a2.5 2.5 0 0 1 2.5-2.5H9A2.5 2.5 0 0 1 11.5 4v3A2.5 2.5 0 0 1 9 9.5H2.707l.647.646a.5.5 0 0 1-.708.708l-1.5-1.5a.5.5 0 0 1 0-.708l1.5-1.5a.5.5 0 1 1 .708.708l-.647.646H9A1.5 1.5 0 0 0 10.5 7V4A1.5 1.5 0 0 0 9 2.5H6.5Zm-1 1.25a.5.5 0 0 1 .5-.5h3.5a.5.5 0 0 1 0 1H6a.5.5 0 0 1-.5-.5ZM9.5 6H6a.5.5 0 0 1 0-1h3.5a.5.5 0 0 1 0 1Zm-1 1.75H6a.5.5 0 0 1 0-1h2.5a.5.5 0 0 1 0 1Z",
  "clip-rule": "evenodd"
}, null, -1), m = [
  _
];
function u(e, h, i, f, p, a) {
  return s(), r("svg", {
    "aria-label": i.ariaLabel,
    class: n([a.iconSizeClass, "d-icon d-icon--past-conversations"]),
    "data-qa": a.dataQA,
    "aria-hidden": a.ariaHidden,
    role: "img",
    "data-name": "Past Conversations",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 13 12"
  }, m, 10, c);
}
const g = /* @__PURE__ */ d(l, [["render", u]]);
export {
  g as default
};
//# sourceMappingURL=past-conversations.js.map
